import { JobCategory } from '../../types/agentTypes';
import { axiosClient } from '../axiosClient';

export interface CreateJobCategoryData {
  name: string;
  description: string;
  department_id: string;
  icon_url?: string;
}

export const jobCategoryFunctions = {
  fetchJobCategoriesList: async (): Promise<JobCategory[]> => {
    return await axiosClient.get('api/job-categories/')
  },

  updateJobCategory: async (id: string, data: CreateJobCategoryData): Promise<JobCategory> => {
    return await axiosClient.put(`api/job-categories/${id}/`, data)
  },

  createJobCategory: async (data: CreateJobCategoryData): Promise<JobCategory> => {
    return await axiosClient.post('api/job-categories/', data)
  },

  deleteJobCategory: async (jobCategoryId: string): Promise<void> => {
    await axiosClient.delete(`api/job-categories/${jobCategoryId}/`)
  },
};
